import React from 'react';
import Header from '../header/header';
import Footer from '../footer/footer';

const MentionsLegales = (props) => {
  return (
      <div>
              <Header />
  
      <div id="stage">
  
        <div className="container">
  
              <div className="stage-text">
                <h2>Mentions Légales</h2>
                <br></br>
                <br></br>
                <br></br>
                <p>Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la confiance en l'économie numérique, il est précisé aux utilisateurs du site Swaly forme l'identité des différents intervenants dans le cadre de sa réalisation et de son suivi.</p>
                <br></br>
<h4>Edition du site </h4>
<p>Le présent site, accessible à l’URL https://swaly-forme.netlify.app/ (le « Site »), est édité par :
<br></br>
Line Jibidar, résidant 34 avenue des Pyrénées 31780 Castelginest, de nationalité Française (France), né(e) le 19/06/1980,  inscrite au R.C.S. de TOULOUSE sous le numéro 887672988,</p>

<br></br>
<h4>Hébergement</h4>
<p>Le Site est hébergé par la société netlify, situé 44 Montgomery St Ste 300, San Francisco, CA 94104, (contact téléphonique ou email : +14156751035).</p>
<br></br>
<h4>Directeur de publication </h4>
Le Directeur de la publication du Site est Line Jibidar.
<br></br>
<br></br>
<h4>Nous contacter </h4>
<p>Par téléphone : +33617497375
  <br></br>
Par email : swalyforme@gmail.com
<br></br>
Par courrier : 34 avenue des Pyrénées 31780 Castelginest</p>
<br></br>
<h4>Conception et réalisation </h4>
<p>Yasmine Ibrahim
  <br></br>
yasmine.ibrahim.dev@gmail.com</p>
<br></br>
<br></br>
<p>Génération des mentions légales par <a href="https://www.legalstart.fr/" target="blank">Legalstart</a>.</p>

  
   </div>
            </div>
          </div>
  
     
        <Footer />
  
      </div>
    );
  };
export default MentionsLegales;